<template>
    <DefaultPanel :class="minimize? 'hotel-panel minimize' : 'hotel-panel'" :minimize="minimize" title="Hotel selezionato" :is-selected="selected">
        <template>
            <div class="row no-gutters">
                <div :class="(minimize? 'col-12' : 'col-12 col-md-4') + ' position-relative'">
                    <div v-if="isAppartamento" class="top-box">
                        <span>appartamento</span>
                    </div>
                    <small-carousel v-if="images" :images="images" :autoplay="false"/>
                </div>
                <div :class="minimize? 'col-12 px-1 minimize' : 'col-12 col-md-8 right'">
                    <div>
                        <div class="border-bottom pb-1 mb-1">
                            <div :class="minimize? '' : 'd-md-flex justify-content-between'">
                                <RatingStars :value="valueC.rating" />
                                <div v-if="valueC.period">
                                    <img src="../../../../assets/images/svg/black/icone_durata.svg" height="18px"/>
                                    <b class="text-uppercase">{{valueC.period}}</b>
                                </div>
                            </div>
                            <h4 class="mb-0" style="height: 25px; overflow: hidden">{{valueC.nome}}</h4>
                            <p v-if="payoff" class="mb-0 font-weight-bold text-primary">{{payoff}}</p>
                        </div>
                        <div class="border-bottom pb-1 mb-1">
                            <div v-if="valueC.indirizzo">
                                <img src="../../../../assets/images/svg/black/icone_pin.svg" height="12px"/>
                                <span>{{valueC.indirizzo}}</span>
                            </div>
                            <div v-if="valueC.descrizione" class="d-flex" style="height: 40px; overflow: hidden">
                                <img class="mt-1 mr-1" src="../../../../assets/images/svg/black/icone_lingua.svg" height="12px"/>
                                <span class="mt-1 d-block font-italic" style="line-height: 12px" v-html="valueC.descrizione"></span>
                            </div>
                        </div>
                        <div :class="minimize? '' : 'd-md-flex justify-content-between'">
                            <div v-if="selected">
                                <div v-for="(item, index) in roomsSelected" :key="index">
                                    <small v-if="!minimize" style="width: 55px;">CAMERA {{index + 1 }}</small>
                                    <small><b>{{getRoomHotelName(item)}}</b></small>
                                </div>
                            </div>
                            <div v-else></div>
                            <div v-if="!minimize" class="d-flex justify-content-between mt-1" style="height: 30px">
                                <h5 v-if="selected && isMobile" class="position-relative text-primary default-bold text-uppercase" style="line-height: 30px">selezionato</h5>
                                <h6 v-if="selected && !isMobile" class="position-relative text-primary default-bold text-uppercase" style="top: 8px; right: 10px">selezionato</h6>
                                <div v-if="!selected" class="position-relative" style="left: -10px; top: 4px">
                                    <h4 :class="deltaPrice > 0? 'more currency' : 'minus currency'">{{sign}} {{abs}} &euro;</h4>
                                </div>
                                <button v-if="!selected" class="py-1 btn btn-primary mr-1" @click="onAdd">seleziona</button>
                                <div class="icon-circle-border-blue mr-1">
                                    <a href="javascript:void(0)" @click="onDetail">
                                        <img src="../../../../assets/images/svg/blue/icone_dettagli.svg" width="16px"/>
                                    </a>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mt-2" v-else>
                                <div :class="`d-flex ${isMobile? 'justify-content-between w-100 mr-1' : 'text-right'}`">
                                    <h6 v-if="selected" class="text-primary default-bold text-uppercase position-relative mr-2" style="top: 7px">selezionato</h6>
                                    <div v-if="!selected" class="position-relative" style="left: 0px; top: 4px">
                                        <h4 :class="deltaPrice > 0? 'nowrap more currency' : 'nowrap minus currency'">{{sign}} {{abs}} &euro;</h4>
                                    </div>
                                    <button v-if="!selected" class="px-2 py-1 btn btn-primary ml-2" @click="onAdd">seleziona</button>
                                </div>
                                <div class="d-flex text-right">
                                    <div class="icon-circle-border-blue mr-1">
                                        <a href="javascript:void(0)" @click="onDetail">
                                            <img src="../../../../assets/images/svg/blue/icone_dettagli.svg" width="16px"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </DefaultPanel>
</template>

<script>
import {mapGetters} from 'vuex'
import DefaultPanel from '../../../templates/DefaultPanel'
import { Carousel, Slide } from 'vue-carousel'
import CarouselOne from '../../common/CarouselOne'
import {hotelName, roomHotelName} from '../../../../utils/helper'
import RatingStars from '../../../common/RatingStars'
import SmallCarousel from '../../common/SmallCarousel'
import {middleDateFormatter} from '../../../../utils/formatter'
import AnalyticEvents from '../../../common/AnalyticEvents'
import MobileDetector from '../../../common/MobileDetector'
import BackofficeActions from '../../../actions/BackofficeAction'
import HotelActions from '../../../actions/HotelAction'

export default {
  name: 'HotelPanel',
  mixins: [AnalyticEvents, MobileDetector, BackofficeActions, HotelActions],
  components: { SmallCarousel, RatingStars, CarouselOne, Carousel, Slide, DefaultPanel },
  props: {
    value: {
      type: Object
    },
    selected: {
      type: Boolean,
      default: false
    },
    minimize: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      images: this.makeImages()
    }
  },
  watch: {
    value () {
      this.images = null
      this.$nextTick(() => {
        this.images = this.makeImages()
      })
    }
  },
  computed: {
    valueC: function () {
      const { location, summary, detail } = this.value.hotel
      const name = hotelName(location.name)
      const { address, city, country, postalCode } = location
      const { phone, web } = detail || {}
      const indirizzo = address + ', ' + (postalCode ? postalCode + ' ' : '') + city + ' (' + country.objB + ')'
      const rating = this.getTypesRating().find(function (item) {
        return item.type === summary.rate
      })
      return {
        nome: name,
        rating: rating ? Math.round(rating.value) : 0,
        indirizzo: indirizzo,
        telefono: phone,
        descrizione: this.description,
        web: web,
        period: middleDateFormatter(this.value.period.start) + ' - ' + middleDateFormatter(this.value.period.end)
      }
    },
    description () {
      const {summary, extra} = this.value.hotel
      return (extra && extra.description ? extra.description : summary.description).substr(0.100)
    },
    roomsSelected () {
      const { rooms } = this.value
      return rooms.filter(function (item) {
        return item.availabilityData.available
      }).filter(function (item) {
        return item.selected
      })
    },
    totalPriceSelectedHotel () {
      const hotel = this.$store.getters.getSelectedHotelsByPeriod(this.value.period)[0]
      return hotel.venditaTotaleEuroBase
    },
    totalPriceHotel () {
      return this.value.venditaTotaleEuroBase
    },
    price () {
      return this.totalPriceHotel
    },
    deltaPrice () {
      return this.totalPriceHotel - this.totalPriceSelectedHotel
    },
    sign () {
      return this['deltaPrice'] > 0 ? '+' : '-'
    },
    abs () {
      return Math.abs(this.deltaPrice)
    },
    config () {
      return this.searchBackofficeHotel(this.value.hotel)
    },
    payoff () {
      if (this.config) {
        return this.config.payoff
      }
      return null
    },
    isAppartamento () {
      if (this.config) {
        return this.config.isAppartamento
      }
      return false
    }
  },
  methods: {
    ...mapGetters(['getTypesRating', 'getHotels']),
    onDetail () {
      this.trackTabHotelInfo()
      this.$emit('detail', this.value)
    },
    makeImages () {
      const { extra, detail, summary } = this.value.hotel
      if (extra && extra.images.length > 0) return extra.images
      if (detail.images.length > 0) return detail.images.map(item => item.objA)
      return [{objA: summary.imageUrl, objB: summary.thumbnailUrl}]
    },
    getRoomHotelName (item) {
      return roomHotelName(item.roomInfo.description)
    },
    onAdd () {
      this.trackModaleListaHotelSeleziona(this.valueC.nome)
      this.value.selected = true
      this.addHotelAction(this.value)
      this.$emit('select', this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/HotelPanel.vue